<script lang="ts">
    import type { ActivityAxisType, MagicBucketsData } from "@/Common/constants";
    import type { MyFitnessStores } from "@/MyFitness/stores";
    import { format_duration } from "@/time";
    import { getXertAm5, type am5Root, type am5xyChart } from "@/Util/XertAm5";
    import { getContext, onMount } from "svelte";

    export let data: MagicBucketsData

    const myFitness = getContext<MyFitnessStores>('myFitness')
    const { userParams } = myFitness

    const { 
		am5, am5xy, MyTheme, MyLineSeries, createCursor, createMyDateAxis, createPowerAxis, createPowerFillSeries,
        createMPASeries, createPeakPowerItem, createThresholdPowerItem
	} = getXertAm5()
    am5.addLicense('AM5C87942260');

    let chartElement: HTMLElement
    let root: am5Root
    let chart: am5xyChart
    let startingAxisType: ActivityAxisType = "time"

    onMount(() => {

        // TODO: This is copied right now between charts. Maybe create a standardXertChart() ??
      	root = am5.Root.new(chartElement);
        root.setThemes([MyTheme.new(root)]);

        chart = root.container.children.push(am5xy.XYChart.new(root, {
            paddingLeft: 0,
            paddingTop: -8,
            layout: root.verticalLayout,
        }) );

        chart.topPlotContainer.children.removeValue(chart.zoomOutButton);
        let buttonsContainer = chart.topPlotContainer.children.push(am5.Container.new(root, {
            layout: root.horizontalLayout,
            width: am5.p100,
            paddingRight: 10,
            //x: am5.p100
        }));

        buttonsContainer.children.push(am5.Container.new(root, {
            width: am5.p100,
        }));
        let zoomOutButton = buttonsContainer.children.push(chart.zoomOutButton);
        // Hack because am5 has a bug where zoomOut doesn't hide the button like it should
        //@ts-expect-error
        chart._handleZoomOut = ()=>{
            // Only compare x-axis for zoom button.
            if ((dateAxis.get('start') == 0) && (dateAxis.get('end') == 1)) {
                zoomOutButton.hide();
            } else {
                zoomOutButton.show();
            }
        };

		const cursor = createCursor({root, chart, handleChange: (pos) => {}})

		const {dateAxis, setMainDataSeries, setValidateData, createScrollbar} = createMyDateAxis({root, chart, startingAxisType, distanceUnits: $userParams.activityUnits['dist'], handleRangeChange: () => {}, groupData: false})
        const {sbDateAxis, sbFillSeries} = createScrollbar({root, chart})
        const powerAxis = createPowerAxis({root, chart})
        const {powerFillSeries, resetGradientStops} = createPowerFillSeries({root, chart, dateAxis, startingAxisType, axis: powerAxis, signature: data.signature})
        const MPASeries = createMPASeries({root, chart, dateAxis, startingAxisType, axis: powerAxis})
        const peakPowerDataItem = createPeakPowerItem(powerAxis)
        const thresholdPowerDataItem = createThresholdPowerItem(powerAxis)

        powerFillSeries.get('tooltip').adapters.add("labelText", (text, target: any) => {
            var targetDataItem = target.dataItem
            if (targetDataItem) {
                const time = target.dataItem.get("valueX") / 1000
                for (let interval of data.intervals) {
                    if(time < interval.range.end) {
                        for (let i = 1; i <= interval.interval_count; i++) {
                            if (time < interval.range.start + i*interval.range.duration + (i-1)*(interval.range?.rib_duration ?? 0)) {
                                text += `\n${interval.name}: [bold]${format_duration(interval.range.duration)}`
                                return text
                            } else if (interval.range?.rib_duration && time < interval.range.start + i*(interval.range.duration + interval.range.rib_duration)) {
                                text += `\nRecovery: [bold]${format_duration(interval.range.rib_duration)}`
                                return text
                            }
                        }
                    }
                }
            }
            return text
        })

        setMainDataSeries(powerFillSeries)

		function validateData() {
			resetGradientStops();

            thresholdPowerDataItem.set('value', data.signature.ftp)
        	peakPowerDataItem.set('value', data.signature.pp)

            const chartSeries = [powerFillSeries, MPASeries, sbFillSeries]

            for (let series of chartSeries) {
                series.setDataUngrouped(data.records)
            }

            return {
                unixTimeEnd: data.records[data.records.length-1].unix_time,
                mmEnd: -1 // This shouldn't ever be accessed because the axis is always time 
			}
        }
		validateData()
		setValidateData(validateData)
    })
</script>

<div bind:this={chartElement} class="h-64"/>